import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_VIEW_REFERRALS
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetViewReferralAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewReferrals as SetGetViewReferrals
}